import { useState } from "react";
import { apiFetch } from "../services/api.js";

export default function SorteioExecutorSimples({
  campanhas = [],
  anuais = [],
  onSucesso,
}) {
  const [tipoSorteio, setTipoSorteio] = useState("campanha");
  const [sorteioSelecionado, setSorteioSelecionado] = useState("");
  const [resultados, setResultados] = useState([]);
  const [mostrando, setMostrando] = useState(false);
  const [executando, setExecutando] = useState(false);
  const [erro, setErro] = useState("");

  // Filtrar apenas campanhas/anuais ativos e não arquivados
  const campanhasAtivas = campanhas.filter(
    (c) => c.ativo !== false && c.arquivado !== true,
  );
  const anuaisAtivos = anuais.filter(
    (a) => a.ativo !== false && a.arquivado !== true,
  );
  const itemsSelecionaveis =
    tipoSorteio === "campanha" ? campanhasAtivas : anuaisAtivos;

  async function handleExecutarSorteio() {
    setErro("");
    setExecutando(true);

    try {
      if (!sorteioSelecionado) throw new Error("Selecione um sorteio");

      const sorteio = itemsSelecionaveis.find(
        (s) => s.id === sorteioSelecionado,
      );
      if (!sorteio) throw new Error("Sorteio não encontrado");

      const rota =
        tipoSorteio === "campanha"
          ? `campanhas/${sorteioSelecionado}/sortear`
          : `anuais/${sorteioSelecionado}/sortear`;

      const res = await apiFetch(rota, {
        method: "POST",
        body: JSON.stringify({
          quantidade_premios: sorteio.quantidade_premios || 1,
        }),
      });

      const ganhadores = res.resultado?.vencedores || [];
      setResultados(ganhadores);
      setMostrando(true);

      console.log(
        `[SORTEIO EXECUTADO] Tipo: ${tipoSorteio}, Ganhadores: ${ganhadores.length}`,
      );
    } catch (err) {
      setErro(err.message || "Erro ao executar sorteio");
      console.error("[ERRO SORTEIO]", err);
    } finally {
      setExecutando(false);
    }
  }

  async function handleRerollUnico(posicao) {
    try {
      setExecutando(true);

      // Buscar cupons novamente
      let cuponsDisponíveis = [];
      if (tipoSorteio === "campanha") {
        const res = await apiFetch(`cupons/campanha/${sorteioSelecionado}`);
        cuponsDisponíveis = res.cupons || [];
      } else {
        const campanhasVinculadas = await apiFetch(
          `anuais/${sorteioSelecionado}/campanhas`,
        );
        const cupomsPorCampanha = await Promise.all(
          (campanhasVinculadas.campanhas || []).map((c) =>
            apiFetch(`cupons/campanha/${c.id}`).then((r) => r.cupons || []),
          ),
        );
        cuponsDisponíveis = cupomsPorCampanha.flat();
      }

      if (!cuponsDisponíveis.length) throw new Error("Nenhum cupom disponivel");

      // Selecione aleatoriamente um cupom
      const cupomAleatório =
        cuponsDisponíveis[Math.floor(Math.random() * cuponsDisponíveis.length)];

      // Buscar dados do cliente para o cupom selecionado
      const clientesRes = await apiFetch("clientes");
      const cliente = (clientesRes.clientes || []).find(
        (c) => c.id === cupomAleatório.cliente_id,
      );

      // Criar novo ganhador com dados completos
      const novoGanhador = {
        ...cupomAleatório,
        cliente_nome: cliente?.nome || "N/A",
        cliente_documento: cliente?.documento || "N/A",
      };

      setResultados((prev) =>
        prev.map((r, idx) => (idx === posicao - 1 ? novoGanhador : r)),
      );

      console.log(
        `[REROLL] Posicao ${posicao} re-sorteada: ${novoGanhador.cliente_nome}`,
      );
    } catch (err) {
      setErro(err.message || "Erro ao reroll");
    } finally {
      setExecutando(false);
    }
  }

  function handleRefazer() {
    setMostrando(false);
    setResultados([]);
  }

  if (mostrando) {
    return (
      <div
        style={{
          backgroundColor: "#f9f9f9",
          padding: "1.5rem",
          borderRadius: "8px",
          marginBottom: "2rem",
        }}
      >
        <h3>Resultado do Sorteio</h3>

        {resultados.length > 0 && (
          <div
            style={{
              backgroundColor: "#e3f2fd",
              padding: "1rem",
              borderRadius: "4px",
              marginBottom: "1rem",
            }}
          >
            <p style={{ margin: "0.25rem 0" }}>
              <strong>Total de Prêmios: {resultados.length}</strong>
            </p>
            <p
              style={{ margin: "0.25rem 0", color: "#666", fontSize: "0.9rem" }}
            >
              {tipoSorteio === "campanha"
                ? campanhas.find((c) => c.id === sorteioSelecionado)?.nome
                : anuais.find((a) => a.id === sorteioSelecionado)?.nome}
            </p>
          </div>
        )}

        {resultados.length === 0 ? (
          <p>Nenhum ganhador</p>
        ) : (
          <>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "1rem",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#333", color: "white" }}>
                  <th style={{ padding: "0.75rem", textAlign: "left" }}>
                    Posicao
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "left" }}>
                    Nome
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "left" }}>
                    CPF/CNPJ
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "left" }}>
                    Cupom
                  </th>
                  <th style={{ padding: "0.75rem", textAlign: "center" }}>
                    Acoes
                  </th>
                </tr>
              </thead>
              <tbody>
                {resultados.map((ganhador, idx) => (
                  <tr
                    key={idx}
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <td style={{ padding: "0.75rem", fontWeight: "bold" }}>
                      {idx + 1}
                    </td>
                    <td style={{ padding: "0.75rem" }}>
                      {ganhador.cliente_nome || "N/A"}
                    </td>
                    <td style={{ padding: "0.75rem" }}>
                      {ganhador.cliente_documento || "N/A"}
                    </td>
                    <td
                      style={{
                        padding: "0.75rem",
                        fontWeight: "bold",
                        color: "#0066cc",
                      }}
                    >
                      {ganhador.codigo}
                    </td>
                    <td style={{ padding: "0.75rem", textAlign: "center" }}>
                      <button
                        onClick={() => handleRerollUnico(idx + 1)}
                        disabled={executando}
                        style={{
                          padding: "0.4rem 0.8rem",
                          backgroundColor: "#ff9800",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "0.9rem",
                        }}
                      >
                        {executando ? "..." : "Reroll"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              onClick={handleRefazer}
              disabled={executando}
              style={{
                padding: "0.75rem 1.5rem",
                backgroundColor: "#d9534f",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "1rem",
              }}
            >
              Refazer Sorteio
            </button>
          </>
        )}
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#f9f9f9",
        padding: "1.5rem",
        borderRadius: "8px",
        marginBottom: "2rem",
      }}
    >
      <h3>Executar Sorteio</h3>

      <div>
        <label>Tipo de Sorteio:</label>
        <select
          value={tipoSorteio}
          onChange={(e) => {
            setTipoSorteio(e.target.value);
            setSorteioSelecionado("");
          }}
          disabled={executando}
        >
          <option value="campanha">Campanha</option>
          <option value="anual">Sorteio Anual</option>
        </select>
      </div>

      <div>
        <label>
          {tipoSorteio === "campanha"
            ? "Selecione a Campanha:"
            : "Selecione o Sorteio Anual:"}
        </label>
        <select
          value={sorteioSelecionado}
          onChange={(e) => setSorteioSelecionado(e.target.value)}
          disabled={executando}
        >
          <option value="">-- Selecione --</option>
          {itemsSelecionaveis?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.nome} ({item.quantidade_premios || item.numero_premios}{" "}
              premios)
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={handleExecutarSorteio}
        disabled={executando || !sorteioSelecionado}
        style={{
          padding: "0.75rem 1.5rem",
          backgroundColor: "#5cb85c",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "1rem",
        }}
      >
        {executando ? "Executando..." : "Executar Sorteio"}
      </button>

      {erro && <p className="error-message">{erro}</p>}
    </div>
  );
}
